import { Notyf } from 'notyf';
import 'notyf/notyf.min.css'; // for React, Vue and Svelte

// Initialize Notyf instance
const notyf = new Notyf({
    duration: 3000,
    position: { x: 'right', y: 'top' },
    dismissible: true
});

// update quantity from cart page
const qtyInputs = document.querySelectorAll('.cart-page .quantity-input');
//console.log(qtyInputs);
if(qtyInputs.length > 0) {
    qtyInputs.forEach(input => {
        input.addEventListener('change', function(e) {
            // name of the input is the line item
            const lineItem = this.name;
            const itemName = this.dataset.name;
            const newQty = parseInt(this.value);
            console.log(lineItem, itemName, newQty);
            if (newQty < 0) {
                notyf.error('Quantity cannot be negative');
                return;
            }

            const formData = new FormData();
            formData.append(lineItem, newQty);
            formData.append('CRAFT_CSRF_TOKEN', csrfToken);
            formData.append('action', 'commerce/cart/update-cart');

            fetch('/shop/cart', {
                method: 'POST',
                body: formData,
                headers: {
                  'Accept': 'application/json',
                },
            })
            .then(response => response.json())
            .then(data => {
                localStorage.setItem('flashMessage', `Updated ${itemName} quantity to ${newQty}.`);
                window.location.reload();
            })
            .catch(error => {
                console.error('Error:', error);
                notyf.error('An error occurred while updating the cart');
            });
        });
    });
}

// remove item from cart
document.querySelectorAll('[data-remove-item]').forEach(removeBtn => {
    removeBtn.addEventListener('click', () => {
        const itemId = removeBtn.dataset.removeItem;
        const itemName = removeBtn.dataset.removeItemName;
        const checkbox = document.querySelector('.remove-item-' + itemId);
        checkbox.checked = true;

        const formData = new FormData();
        formData.append('lineItems[' + itemId + '][remove]', 1);
        formData.append('CRAFT_CSRF_TOKEN', csrfToken);
        formData.append('action', 'commerce/cart/update-cart');

        fetch('/shop/cart', {
            method: 'POST',
            body: formData
        })
        .then(response => {
            if(response.status === 200) {
                localStorage.setItem('flashMessage', `Removed ${itemName} from cart.`);
                window.location.reload();
            } else {
                localStorage.setItem('flashMessage', `Something went wrong.`);
                window.location.reload();
            }
        }).catch(error => {
            localStorage.setItem('flashMessage', `Something went wrong.`);
            window.location.reload();
        });
    });
});

// add to cart for single variant
const formSingleVariant = document.getElementById('product-variants-form-single-variant');
if (formSingleVariant) {
    formSingleVariant.addEventListener('submit', (e) => {
        e.preventDefault();

        const hiddenQty = document.getElementById('hidden-qty');
        const qtyInput = document.querySelector('.product-variants-qty-single-variant .quantity-input');
        if(hiddenQty) {
            hiddenQty.value = qtyInput.value;
        }

        console.log(hiddenQty, qtyInput);

        formSingleVariant.submit();
    });
}

// add to cart for multiple variants
const form = document.getElementById('product-variants-form');
if (form) {
    form.addEventListener('submit', (e) => {

        e.preventDefault();

    const allVariants = document.querySelectorAll('.product-variants input.quantity-input');
    const allVariantsQty = Array.from(allVariants).map(variant => parseInt(variant.value));
    console.log(allVariantsQty);
    
    if(allVariantsQty.every(variant => variant === 0)) {
        // find the closest form
        notyf.error('Please select at least one variant.');
        } else {
            form.submit();
        }
    });
}


document.addEventListener('DOMContentLoaded', () => {
    const flashMessage = localStorage.getItem('flashMessage');
    if (flashMessage) {
        // Show the flash message using your notification library
        notyf.success(flashMessage);
        // Clear the flash message from localStorage
        localStorage.removeItem('flashMessage');
    }
});

// apply coupon code
const couponButton = document.querySelector('#couponButton');
let couponCode = document.getElementById('couponCode');
const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
if (couponButton) {
    // add event listener to couponCode input when enter key is pressed
    couponCode.addEventListener('keydown', (e) => {
        if(e.key === 'Enter') {
            couponButton.click();
        }
    });
    couponButton.addEventListener('click', (e) => {
        e.preventDefault();

        const couponCodeValue = couponCode.value;

        if(!couponCodeValue) {
            notyf.error('Please enter a coupon code.');
            return;
        }

        const formData = new FormData();
        formData.append('couponCode', couponCodeValue);
        formData.append('CRAFT_CSRF_TOKEN', csrfToken);
        formData.append('action', 'commerce/cart/update-cart');
        
        fetch('/shop/cart', {
            method: 'POST',
            body: formData,
            headers: {
              'Accept': 'application/json',
            },
        })
        .then(response => response.json())  // Parse the JSON response
        .then(data => {
            console.log(data);
            if (!data.cart.couponCode) {
                notyf.error('Coupon code is invalid.');
            } else {
                notyf.success('Coupon code applied.');
                setTimeout(() => {
                    window.location.reload();  // Reload to show updated cart
                }, 1000);
            }
        })
        .catch(error => {
            // window.location.reload();
            console.log('Error:', error);
            notyf.error('An error occurred while applying the coupon.');
        });
    });
}

// remove coupon code
const removeCouponBtn = document.querySelector('.remove-coupon');
if(removeCouponBtn) {
    removeCouponBtn.addEventListener('click', (e) => {
        e.preventDefault();
        
    const formData = new FormData();
    formData.append('CRAFT_CSRF_TOKEN', csrfToken);
    formData.append('action', 'commerce/cart/update-cart');
    formData.append('couponCode', '');

    fetch('/shop/cart', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
        console.log(data);
        window.location.reload();
    })
        .catch(error => {
            console.log('Error:', error);
        });
    });
}


const saveOrderBtn = document.getElementById('saveOrderBtn');
if(saveOrderBtn) {
    saveOrderBtn.addEventListener('click', (e) => {
        e.preventDefault();
        fetch('/actions/site/saved-order/save-cart', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Show success notification using Notyf
                notyf.success(data.message);

                // Optionally, redirect to the saved order page
                window.location.href = '/shop/customer/saved-order/' + data.listId;
            } else {
                // Show error notification if something went wrong
                notyf.error('There was an issue saving your order.');
            }
        })
        .catch(error => {
            // Show error notification in case of network or other errors
            notyf.error('An unexpected error occurred.');
        });
    });
}

const continueToPaymentBtn = document.getElementById('continue-to-payment');
if(continueToPaymentBtn) {
    continueToPaymentBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const cartBillingAddressId = e.target.dataset.cartBillingAddressId;
        const cartShippingAddressId = e.target.dataset.cartShippingAddressId;
        let msg = '';
        // console.log(cartBillingAddressId, cartShippingAddressId, e.target.dataset);

        if(!cartBillingAddressId || cartBillingAddressId === '') {
            msg += 'Please select a billing address. <br>';
        }
        if(!cartShippingAddressId || cartShippingAddressId === '') {
            msg += 'Please select a shipping address. <br>';
        }
        if(msg) {
            notyf.error(msg);
        } else {
            document.getElementById('checkout-form').submit();
        }
    });
};

document.addEventListener('DOMContentLoaded', function () {
    // Check if elements exist before proceeding
    const paymentForm = document.getElementById('payment-form');
    if (!paymentForm) return;

    const creditCardFields = document.getElementById('credit-card-fields');
    if (!creditCardFields) return;

    const gatewayInputs = paymentForm.querySelectorAll('input[name="gatewayId"]');
    const paymentSourceId = paymentForm.querySelectorAll('input[name="paymentSourceId"]');
    const dummyInput = document.querySelectorAll('input[name="dummyInput"]');

    function toggleCreditCardFields(handler) {
        if(handler && typeof handler !== 'undefined') {
            if (handler !== 'stripe') {
                creditCardFields.style.display = 'none';
            } else {
                //first input radio check
                paymentSourceId[0].checked = true;
                creditCardFields.style.display = 'block';
            }
        }
    }
    if(gatewayInputs && gatewayInputs.length > 0) {
        gatewayInputs.forEach(input => {
            input.addEventListener('change', () => {
                toggleCreditCardFields(input.dataset.gatewayHandle);
            });
        });
    }

    if(dummyInput) {
        dummyInput.forEach(input => {
            input.addEventListener('change', () => {
                toggleCreditCardFields(input.dataset.gatewayHandle);
            });
        });
    }

    const selectedGateway = paymentForm.querySelector('input[name="gatewayId"]:checked');
    const selectedDummyInput = paymentForm.querySelector('input[name="dummyInput"]:checked');
    if (selectedDummyInput) {
        toggleCreditCardFields(selectedDummyInput.dataset.gatewayHandle);
    } else if (selectedGateway) {
        toggleCreditCardFields(selectedGateway.dataset.gatewayHandle);
    }
});

document.addEventListener("DOMContentLoaded", function () {
    // Get the select element using its data attribute
    let tradeCountrySelect = document.querySelector("[data-fui-id='tradeAccountRegistration-billingAddress-country']");
    let tradeShippingCountrySelect = document.querySelector("[data-fui-id='tradeAccountRegistration-shippingAddress-country']");

    if (tradeCountrySelect) {
        updateCountrySelect(tradeCountrySelect);
    }

    if (tradeShippingCountrySelect) {
        updateCountrySelect(tradeShippingCountrySelect);
    }

    function updateCountrySelect(countrySelect) {
        let allowedCountries = ["AU", "NZ"];

        Array.from(countrySelect.options).forEach(option => {
            if (!allowedCountries.includes(option.value) && option.value !== "") {
                option.remove();
            }
        });
    }
});